// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_dfd7058","returns":"_d467a20","description":"_8f3deb4","value":"_44e43f0","bonusCash":"_c9cd157","returnValue":"_18c5cd4","returnValuePriceChange":"_d98f217"};